import { UntilDestroy } from "@ngneat/until-destroy";
import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { IButtonDirective, ModalRef } from "@front/m19-ui";
import { TranslocoDirective } from "@jsverse/transloco";

@UntilDestroy()
@Component({
  selector: "app-data-warehouse-activation",
  imports: [TranslocoDirective, IButtonDirective],
  templateUrl: "./data-warehouse-activation-modal.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DataWarehouseActivationModalComponent {
  private readonly modalRef = inject(ModalRef);

  protected close() {
    this.modalRef.close(true);
  }
}
